const initialState = ['example']

const exampleReducer = (state:string[] = initialState, action:any) => {
    switch (action.type) {
        case 'SET_EXAMPLE':
            state = action.payload;
            return state;
        default:
            return state
    }
}

export default exampleReducer